import { Attachment } from "../types";

export function image(
  image: string | Attachment,
  options: { w?: number; h?: number; q?: number; fm?: string },
): string {
  try {
    if (typeof image === "object") {
      image = image.url;
    }

    // now let's construct the image url
    const url = new URL(image);

    if (options.w) {
      url.searchParams.set("w", options.w.toString());
    }

    if (options.h) {
      url.searchParams.set("h", options.h.toString());
    }

    if (options.q) {
      url.searchParams.set("q", options.q.toString());
    }

    if (options.fm) {
      url.searchParams.set("fm", options.fm);
    }

    return url.toString();
  } catch {
    return "";
  }
}
